import { Link } from "react-router-dom";
import { SERVICES } from "@/data/services";
import { ArrowUpRight, Check } from "lucide-react";

export default function Pricing() {
  return (
    <div>
      <section className="border-b border-brand-border">
        <div className="container-x pt-20 pb-16 lg:pt-28 lg:pb-20">
          <div className="max-w-3xl">
            <div className="eyebrow mb-3">Pricing</div>
            <h1 className="font-display font-black text-5xl sm:text-6xl tracking-tight" data-testid="pricing-title">Straightforward pricing for every service.</h1>
            <p className="mt-6 text-lg text-brand-muted">Three tiers per service. Custom quotes on request. No hidden fees, no long contracts.</p>
          </div>
        </div>
      </section>

      {SERVICES.map((s) => {
        const Icon = s.icon;
        return (
          <section key={s.slug} className="border-b border-brand-border">
            <div className="container-x py-16 lg:py-20">
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
                <div className="lg:col-span-4">
                  <div className="w-12 h-12 rounded-xl bg-brand-surface flex items-center justify-center mb-5">
                    <Icon className="w-5 h-5 text-brand-ink" />
                  </div>
                  <h2 className="font-display font-bold text-3xl tracking-tight">{s.title}</h2>
                  <p className="mt-3 text-brand-muted leading-relaxed">{s.tagline}</p>
                  <Link to={`/services/${s.slug}`} data-testid={`pricing-learn-${s.slug}`} className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-brand-ink hover:gap-2 transition-all">
                    Learn more <ArrowUpRight className="w-4 h-4" />
                  </Link>
                </div>
                <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-3 gap-4">
                  {s.tiers.map((t) => (
                    <div key={t.name} data-testid={`pricing-tier-${s.slug}-${t.name.toLowerCase()}`}
                      className={`p-6 rounded-2xl border ${t.featured ? "bg-brand-ink text-white border-brand-ink" : "bg-white border-brand-border"}`}>
                      {t.featured && <div className="inline-block text-[10px] px-2 py-1 rounded-full bg-brand-blue text-white mb-3">Popular</div>}
                      <div className={`font-display font-bold text-xl ${t.featured ? "text-white" : "text-brand-ink"}`}>{t.name}</div>
                      <div className="flex items-baseline gap-1 mt-3">
                        <span className={`font-display font-black text-3xl ${t.featured ? "text-white" : "text-brand-ink"}`}>{t.price}</span>
                        <span className="text-xs opacity-70">{t.per}</span>
                      </div>
                      <ul className="mt-4 space-y-2">
                        {t.features.map((f) => (
                          <li key={f} className="flex items-start gap-2 text-xs">
                            <Check className="w-3.5 h-3.5 mt-0.5 shrink-0 text-brand-blue" />
                            <span className={t.featured ? "text-white/80" : "text-brand-muted"}>{f}</span>
                          </li>
                        ))}
                      </ul>
                      <Link to="/contact" data-testid={`pricing-cta-${s.slug}-${t.name.toLowerCase()}`}
                        className={`mt-6 w-full inline-flex items-center justify-center gap-1 px-4 py-2.5 rounded-xl font-medium text-sm ${t.featured ? "bg-white text-brand-ink" : "bg-brand-ink text-white"} hover:opacity-90`}>
                        Get Started <ArrowUpRight className="w-3.5 h-3.5" />
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        );
      })}

      <section className="container-x py-20">
        <div className="bg-brand-surface rounded-3xl p-12 text-center">
          <h2 className="font-display font-bold text-3xl sm:text-4xl">Need something custom?</h2>
          <p className="mt-3 text-brand-muted">We craft custom engagements for complex briefs. Tell us what you're building.</p>
          <Link to="/contact" data-testid="pricing-custom-cta" className="btn-primary mt-8">Request a Custom Quote</Link>
        </div>
      </section>
    </div>
  );
}
